"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationRegexStr = exports.validationRegex = exports.validationErrorMsgs = exports.formFieldsPlaceHolders = void 0;
//Regex patterns to be used in JS pattern matching
var validationRegex = exports.validationRegex = {
  whiteSpaces: /[\s]/,
  nameRegex: /^[a-zA-Z ,.'-]{3,30}$/,
  shortNameRegex: /^[a-zA-Z ,.'-]{1,30}$/,
  emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  // email, dot, and at least two characters after dot
  phoneRegex: /^[1-9]{1}\d{9}$/,
  car_year: /^\d{4}$/,
  policyPattern: /^([A-Za-z]{1}(\d+)|(\d+))$/,
  customerOrBillingNumberPattern: /^[0-9]{10}(?:[0-9]{2})?$/ // 10 or 12 digits
};
//Regex Strings to be used inside pattern attribute for input fields
//Disabled it in Portal:Registration as we cannot display our detail msg on what is expected here from user
var validationRegexStr = exports.validationRegexStr = {
  whiteSpaces: '[\\s]',
  nameRegex: "^[a-z A-Z ,.'-]{3,30}$",
  shortNameRegex: "^[a-zA-Z ,.'-]{1,30}$",
  emailRegex: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
  phoneRegex: '^[1-9]{1}\\d{9}$',
  car_year: '^\\d{4}$'
};
//Validation Error Msgs to be displayed on UI
var validationErrorMsgs = exports.validationErrorMsgs = {
  whiteSpaces: 'Field should not be empty and white space is not allowed',
  nameRegex: "It should be 3-30 character long and can contain letters and , . ' -",
  shortNameRegex: "It should be 1-30 character long and can contain letters and , . ' -",
  emailRegex: 'Invalid email address format',
  phoneRegex: 'Phone should be 10 digits long. The first digit cannot be 0.',
  termsOfUse: 'Please accept the terms of use.',
  car_year: 'Car Year must be a valid year in 4 digits.',
  policyPattern: '*Please enter a valid policy number.',
  customerOrBillingNumberPattern: '*Please enter a valid customer or billing number.'
};

//Placeholders to be used inside input fields
var formFieldsPlaceHolders = exports.formFieldsPlaceHolders = {
  firstName: 'Enter your nickname',
  lastName: 'Enter your last name',
  email: 'Enter your email address',
  phone: 'Enter your telephone number',
  currentPassword: 'CURRENT PASSWORD',
  currentPasswordPlaceholder: 'Enter your current password',
  password: 'NEW PASSWORD',
  passwordPlacehold: 'Enter your new password',
  confirmPassword: 'CONFIRM PASSWORD',
  confirmPasswordPlaceholder: 'Re-enter your new password',
  car_year: 'Model Year'
};